/* 单词页面 */
/*  Author: wanfengren */
/* create: 2018/11/12*/
<template>
  <div class="container">
    <div class="container_body">
        <!--word header-->
        <div id="header">
          <div class="header-title-word" ><span style="fontSize: 20px">{{Data.word_name}}</span></div>
          <div class="bg"><img src="../../../static/images/PeasonalizedTarget-background.png"></div>
        </div>

        <div id="desc">
          <div class="resource intro">
            <div class="dic-basic-voice">
             <p>
              <span>
                <span class="word_ph">英 [{{Data.ph_en}}]</span><i class="dic-sound" @click="sound(Data.ph_en_mp3)"></i>
              </span>
              <span>
                <span class="word_ph">美 [{{Data.ph_am}}]</span><i class="dic-sound" @click="sound(Data.ph_am_mp3)"></i>
              </span>
            </p>
          </div>

            <p v-for="part in Data.meaning0">
              <span>{{part.part}} </span>
              <span v-for="me in part.means" v-text="me+';'"></span>
            </p>

            <div v-if="Data.exchange0.length > 0 ">
                <h3 class="base-word abbr chinese change-base">变形</h3>
                <p>
                  <span v-if="Data.exchange0.word_pl">
                    <label>复数：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_pl[0]" v-text="Data.exchange0.word_pl[0]"></a>
                  </span>
                  <span v-if="Data.exchange0.word_past">
                    <label>过去式：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_past[0]" v-text="Data.exchange0.word_past[0]"></a>
                  </span>
                  <span v-if="Data.exchange0.word_done">
                    <label>过去分词：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_done[0]">{{Data.exchange0.word_done[0]}}</a>
                  </span>
                 </p>
                <p>
                  <span v-if="Data.exchange0.word_ing">
                    <label>现在分词：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_ing[0]">{{Data.exchange0.word_ing[0]}}</a>
                  </span>
                  <span v-if="Data.exchange0.word_er">
                    <label>比较级：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_er[0]">{{Data.exchange0.word_er[0]}}</a>
                  </span>
                  <span v-if="Data.exchange0.word_third">
                    <label>第三人称单数：</label>
                    <a class="shape" v-bind:href="'http://www.iciba.com/'+ Data.exchange0.word_third[0]">{{Data.exchange0.word_third[0]}}</a>
                  </span>
                 </p>
               <!-- <hr style="height:1px;border:none;margin:0;margin-top:15px;border-top:1px solid #e4e3c7;"> -->
            </div>
          </div>
        </div>

        <div id="resource">
          <div class="resource resource_book" v-if="Data.cover_picture_link">
            <p><span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>51Talk每日一词</strong></span>
            </p>
            <div class="resource-content intro">
              <img class="daily_word_img" :src="Data.cover_picture_link">
              <p>快来听听Nancy老师教我们学单词吧：</p>
              <audio id="media_link" class="audio_dailyword" controls="controls" :src="Data.media_link">
               您的浏览器不支持 audio 标签。
               </audio>
            </div>
          </div>
          <div class="resource resource_cartoon" v-if="Data.sentence0.length > 0">
            <p>
              <span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>双语例句:</strong>
              </span>
             </p>
            <div class="resource-content intro">
              <div class="article-section">
                <div class="section-p">
                  <div class="p-container" v-for="(item,index) in Data.sentence0">
                    <p class="p-english family-english size-english">
                      <span class="p-order">{{index+1}}.</span>
                      <span v-html="highlight(item.Network_en)"></span>
                      <i class="dic-sound" @click.stop.prevent="sound(item.tts_mp3)"></i>
                    </p>
                    <p class="p-chinese family-chinese size-chinese" style="color: RGB(27, 70, 125)" v-text="item.Network_cn"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="resource resource_song" v-if="Data.bidec0.length > 0">
            <p>
              <span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>英汉例句</strong>
              </span>
              </p>
            <div class="resource-content intro">
              <div v-for="(item,index) in Data.bidec0" class="collins-section">
                <div class="section-h">
                  <p class="speech-yellow">
                    <span class="h-order family-english" v-text="numToLetter(index)"></span>
                    <!-- <span class="h-order family-english" v-text="index+1"> -->
                    </span><span class="family-english" v-text="item.part_name"></span>
                  </p>
                </div>
                <div v-if="item.means" v-for="(means,index) in item.means" class="section-prep">
                  <div class="prep-order">
                    <p class="family-chinese size-chinese">
                      <i class="prep-order-icon" v-text="index+1"></i>
                      <span v-text="means.word_mean"></span>
                    </p>
                    <div class="text-sentence">
                      <div v-if="means.sentences" v-for="(sentence,index) in means.sentences" class="sentence-item">
                        <p class="family-english size-english">
                          <i class="circle-icon" v-text="index+1 + '.'"></i>
                          <span  v-html="highlight(sentence.en)"></span>
                        </p>
                        <p class="family-chinese size-chinese" style="color: RGB(38, 80, 18)" v-text="sentence.cn"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           </div>

          </div>
          <div class="resource resource_activity" v-if="Data.synonym0.length > 0">
            <p><span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>同义词</strong></span>
            </p>
            <div class="article-section intro">
              <div v-for="(synonym,index) in Data.synonym0"  class="collins-section">
                 <div v-if="synonym.part_name" class="section-h">
                    <p class="speech-yellow">
                      <span class="h-order family-english" v-text="numToLetter(index)"></span>
                      <span class="family-english" v-text="synonym.part_name"></span>
                    </p>
                 </div>
                 <div v-if="synonym.means" v-for="(means,index) in synonym.means" class="section-prep">
                  <div class="prep-order">
                    <p class="family-chinese size-chinese">
                      <i class="prep-order-icon" v-text="index+1"></i>
                      <span v-text="means.word_mean"></span>
                    </p>
                      <div class="text-sentence">
                        <span v-if="means.cis"  v-for="cis in means.cis">
                          <a v-bind:href="'http://www.iciba.com/'+cis" v-text="cis+' '"></a>
                        </span>
                      </div>
                  </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
    </div>
 </div>
</template>

<script>
require('@/assets/css/peasonalized-target.css')
import 'font-awesome/css/font-awesome.css'
import BaseVue from '@/components/BaseVue'

export default {
  name: 'WordTemplate',
  extends: BaseVue,
  /* inherit from BaseVue,the para in data can call on above */
  data() {
    return {
      Data: {
        word_name: "",
        meaning0: [],
        topic: [],
        topic_level: [],
        sentence0: [],
        bidec0: [],
        synonym0: []
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: function(){
    let data_id = this.$route.params.id
    // if(!isNaN(data_id)){let url= this.APIHOST + 'word/' + data_id +'?cipher=0'+ '&format=json' }
    // else{let url = this.APIHOST + 'word/' + data_id + '?format=json'}
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_word?id=' + data_id  
    // let url= this.APIHOST + 'word/' + data_id +'?cipher=0'+ '&format=json'
    this.url_params = this.$route.fullPath.split('?')[1]
    let that = this;
    /* queryData from basevue */
    this.queryData(url, function(data) {
      that.Data = data
    })
  },
  methods: {
    changeFontSize: function(){
      if (window.innerWidth >500) return 20
      return  parseInt(375 / (18+ Data.word_name.length + 2))
    },
    sound: function(url){
      var audio= new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    },
    trimRegExp: function(e) {
        return e.replace(/([\.\?\+\*\^\(\)\\\{\}\$\/])/g, "\\$1")
      },
    // 句子中出现单词部分加粗
    highlight: function(e){
      var word = this.Data.word_name
      return e.replace(word,"<b style='color: orange'> "+ word + "</b>")
    },
    //不同词性下的编号改为大写字母
    numToLetter: function(e){
      return String.fromCharCode(65 + parseInt(e))
    },
  },
  filters: {
    trimRegExp: function(e){
        return e.replace(/([\.\?\+\*\^\(\)\\\{\}\$\/])/g, "\\$1")
      },
 }
}
</script>



// WEBPACK FOOTER //
// src/components/resource/WordNew.vue